jQuery.fn.highlight = function(a, b) {
    var c = new RegExp(a, "gi");
    return this.each(function() {
        $(this).contents().filter(function() {
            return 3 == this.nodeType && c.test(this.nodeValue)
        }).replaceWith(function() {
            return (this.nodeValue || "").replace(c, function(e) {
                return '<span class="' + b + '">' + e + "</span>"
            })
        })
    })
};
var isPaged = !1,
    inStockOnly = [];
if ($("body").hasClass("template-collection") && -1 == window.location.pathname.indexOf("standard-sizes") && 0 == $("#Collection .grid .grid__item").length && -1 === window.location.href.indexOf("new-custom"))
    if ("/collections/iron-doors/az" == window.location.pathname) window.location.href = "/collections/iron-doors?ap=SHIPAZ";
    else {
        var specialOrderPath = window.location.pathname + "-standard-sizes";
        console.log("redirect?", specialOrderPath)
    }
theme.updateFilterPrice = function(a) {
    a = $(a);
    theme.Currency.formatMoney(parseFloat(a.data("original-regular-price")), theme.moneyFormat);
    var b = theme.Currency.formatMoney(parseFloat(a.data("original-sale-price")), theme.moneyFormat),
        c = b;
    theme.wholesale.isWholesale ? (b = theme.Currency.formatMoney(theme.getWholesalePrice(parseFloat(a.data("original-sale-price"))), theme.moneyFormat), a.find(".product-card__price-sale").html("Dealer Price: " + b), a.find(".product-card__price-regular").html("MSRP: " + c).show()) :
        a.find(".product-card__price-sale").html("From " + b);
    a.addClass("price--updated")
};
theme.updateFilterPricing = function(a) {
    console.log("theme.updateFilterPricing");
    $.each(window.productsJSON, function(b, c) {
        theme.updateFilterPrice(".product-card-" + c.id)
    });
    return !1
};
theme.updatePagedPricing = function() {
    $(".product-card:not(.price--updated)").each(function() {
        theme.updateFilterPrice(this)
    })
};
theme.hideUnavailableSizeFilters = function(a) {
    a = window.location.href.split("?")[0];
    "URLSearchParams" in window && (new URLSearchParams(window.location.search)).set("view", "view-json");
    console.log(a + "/products.json");
    $.get(a + "/products.json", function(b) {
            console.log(b);
            window.productsJSON = b.products;
            $(".size-filter .filter-elem").hide();
            $.each(b.products, function(c, e) {
                $.each(e.variants, function(d, f) {
                    f.available && (d = f.title.split(" / ")[0], $(".size-filter .filter-elem label:contains(" + d + ")").closest(".filter-elem").show())
                })
            })
        },
        "json").done(function(b) {}).fail(function(b) {
        console.log("theme.hideUnavailableSizeFilters error: ", b)
    })
};
theme.removeActiveSizeFilter = function(a) {
    if ($(a).closest(".filter-group").hasClass("size-filter")) {
        var b = $(".size-filter.is--filtered");
        b.find(".coll-filter").not(a).prop("selected", !1).removeAttr("checked");
        b.removeClass("is--filtered").find(".remove").hide();
        b.find(".fg-title").text(b.find(".fg-title").attr("data-original-title"))
    }
};
theme.updateProductLink = function(a, b) {
    a = $("#product-card-" + a + " .grid-view-item__link");
    if (a.length) {
        var c = a.attr("href");
        a.attr("href", c + "?variant=" + b)
    }
};
theme.getLowestVariantPrice = function(a, b) {
    if (0 == b.length) return !1;
    var c = b[0].price,
        e = b[0].compare_at_price;
    $.each(b, function(d, f) {
        f.price < c && (c = f.price, e = f.compare_at_price)
    });
    theme.updateFilteredPrice(a, c, e)
};
theme.updateFilteredPrice = function(a, b, c) {
    a = $(".product-card-" + a);
    if (a.length) {
        c = theme.Currency.formatMoney(c, theme.moneyFormat);
        b = theme.Currency.formatMoney(b, theme.moneyFormat);
        a.find(".product-card__price-sale").html("SALE from " + b);
        a.find(".product-card__price-regular").html("Reg. from " + c);
        c = a.find(".product-card__title:contains('Air 4')").length;
        var e = a.find(".product-card__title:contains('Air 5')").length;
        (c || e) && a.find(".product-card__price-sale").html("From " + b)
    }
};
theme.finishCollectionProcessing = function() {
    theme.noCollectionResults();
    isPaged = !1;
    $.each(inStockOnly, function(a, b) {
        $("#product-card-" + b.id).fadeIn("slow")
    });
    theme.preorderProducts();
    $(".next-page-preloader__svg").fadeOut("slow");
    $(".collection-preloader").fadeOut("slow")
};
var ajaxRequests = [];
theme.hideUnavailableFilterResults = function(a, b) {};
theme.noCollectionResults = function() {
    $(".collection-box").each(function(a, b) {
        a = $(b).find(".grid__item:visible");
        b = $(b).find(".none-available--wrapper");
        0 == a.length ? b.fadeIn() : b.fadeOut()
    })
};
theme.checkRemoveAllButton = function() {
    var a = $(".remove-all");
    1 <= $(".coll-filter:checked").length ? a.addClass("show") : a.removeClass("show")
};
theme.filterData = {
    doorTypesSelected: !1,
    singleDoorSize: !1,
    doubleDoorSize: !1
};
theme.applyFilters = function(a) {
    theme.doorTypesSelected = 0;
    $(".collection-preloader").fadeIn("slow");
    var b = $(".products").data("collection-handle"),
        c = $(a);
    theme.checkRemoveAllButton();
    theme.removeActiveSizeFilter(a);
    c.closest(".filter-group").addClass("is--filtered").find(".fg-title").text(c.next().text());
    a = [];
    var e = [],
        d = [];
    c.closest(".filter-group").find(".remove").fadeIn();
    var f = $("#door-swing-filter input:checked"),
        h = $("#glass-filter input:checked"),
        g = $("#single-door-size-filter input:checked"),
        k = $("#double-door-size-filter input:checked");
    $(".size-filter input:checked");
    f.length && d.push(f.val());
    h.length && d.push(h.val());
    g.length && (theme.doorTypesSelected++, a.push(g.val()), setCookie("single-door", g.next().text(), {
        expires: 5
    }), a = a.concat(d));
    k.length && (theme.doorTypesSelected++, e.push(k.val()), setCookie("double-door", k.next().text(), {
        expires: 5
    }), e = e.concat(d));
    theme.isMobile() ? (c.closest(".filter-group").find(".fg").hide(), $(".filters-inner").fadeOut()) : $(".filter-group.is--open .fg-title").trigger("click");
    $("#collection-grid-0").empty();
    window.productsJSON = [];
    $(".filter-group").removeClass("is--open");
    if (a.length) return theme.filterData.singleDoorSize = a, b = "/collections/" + b + "/" + a.join("+") + "?page=1", theme.getNewCollection(b + "?view=infinite-scroll"), !1;
    if (e.length) return theme.filterData.doubleDoorSize = e, b = "/collections/" + b + "/" + e.join("+") + "?page=1", theme.getNewCollection(b + "&view=infinite-scroll"), !1;
    if (!a.length && !e.length) return d.join("+"), b = "/collections/" + b + "/" + d.join("+") + "?page=1", theme.getNewCollection(b +
        "&view=infinite-scroll"), !1
};
theme.getCollectionPaging = function(a) {
    $.get(a, function(b) {
        b = $(b).find("#collection-grid").data("all-pages").split(",");
        theme.loadAllPages(b, !1)
    })
};
theme.getNewCollection = function(a, b) {
    b = b || !1;
    var c = "#Collection";
    b ? (c = "#Collection-" + b, $("#Collection").empty().hide()) : $("#Collection").show();
    var e = a.split("?")[0];
    a = $.get(a, function(d) {
        $(c).html($(d).find("#Collection").html());
        $(d).find(".pagination--wrapper").length ? $(".pagination--wrapper").html($(d).find(".pagination--wrapper").html()) : $(".pagination--wrapper").remove();
        window.history.replaceState({}, null, e);
        $(c).attr("data-current-page", $(d).find("#Collection").attr("data-current-page"));
        $(window).scroll();
        theme.finishCollectionProcessing();
        theme.isPaging = !1
    });
    ajaxRequests.push(a)
};
theme.getNewCollections = function(a) {
    console.log(a);
    $.each(a, function(b, c) {
        var e = `#collection-grid-${b}`;
        c = $.get(c, function(d) {
            $(e).html($(d).find("#collection-grid-0").html());
            console.log($(".pagination-wrapper").eq(b).length);
            0 == $(".pagination-wrapper").eq(b).length && (console.log("no pagination yet"), $(d).find(".pagination-wrapper").length && (console.log("has pagination"), $("#Collection").append($(d).find(".pagination-wrapper").attr("data-pagination-for", `collection-grid-${b}`))));
            theme.finishCollectionProcessing();
            theme.isPaging = !1
        });
        ajaxRequests.push(c)
    })
};
theme.setCurrentTags = function(a) {
    $(".coll-filter:checked").each(function(b, c) {
        b = $(c).next().text();
        console.log(b);
        $(c).closest(".filter-group").addClass("is--filtered").find(".fg-title").text(b)
    });
    $.each(a, function(b, c) {})
};
theme.setActiveFilter = function(a) {
    var b = $(a).val();
    a = $(a).closest(".filter-group");
    a.addClass("is--filtered").find(".remove").show();
    a.find(".fg-title").text(b)
};
theme.checkActiveFilters = function() {
    $(".filter-group").each(function(a, b) {
        0 == $(b).find(".coll-filter:checked").length && theme.removeActiveFilter(b)
    })
};
theme.removeActiveFilter = function(a) {
    var b = $(a).closest(".filter-group");
    b.find(".remove").hide();
    b.find(".coll-filter").prop("checked", !1);
    b.removeClass("is--filtered");
    var c = b.find(".fg-title").data("original-title");
    b.find(".fg-title").text(c);
    $(a).closest("form").submit()
};
theme.updateCollectionPrices = function() {
  return;
    var a = $('input[name="filter.v.option.size"]:checked');
    0 != a.length && $(".product-card").each(function(b, c) {
        c = $(c).data("variants");
        0 == b && console.log(c);
        var e = c[0].price;
        $.each(c, function(d, f) {
          
            if(f.option1 === $(a).val() && f.price < e) {
              console.log(e);
              e = f.price;
              return;
            }
            // f.option1 == $(a).val() && f.price < e && (e = f.price)
            
        });
        b = theme.Currency.formatMoney(e, theme.moneyFormat);
        $(".ws-sale-price").html(b)
    })
};
theme.renderFilters = function(reset = false) {
    var a = document.querySelector("#CollectionFiltersForm");
    if (!a) return;
    var data = new FormData(a);
    var params;
    if ( reset ) {
        params = 'filter.v.availability=1';
    } else {
        params = new URLSearchParams(data).toString();
    }

    if (params && !params.includes('filter.v.option.size')) {
        $.get(`${window.location.pathname}?section_id=collection-filters&${params}`, function(b) {
            var $form = $(b).find("#CollectionFiltersForm").html();
            $("#CollectionFiltersForm").html($form);
        });
    }
};
theme.collectionFiltersNew = function() {
    theme.renderFilters();
    $(".coll-filter:checked").each(function(a) {
        theme.setActiveFilter(this)
    });
    theme.updateCollectionPrices();
    $(document).on("change", ".coll-filter", function(a) {
        theme.renderFilters();
        theme.setActiveFilter(this);
        theme.checkActiveFilters();
        $(this).closest("form").submit()
    });
    $(document).on("click", ".remove", function(a) {
        theme.removeActiveFilter(this);
        theme.renderFilters(true);
    });
    $(document).on("click touchend", ".filter-group .fg-title", function(a) {
        a.preventDefault();
        $(".filter-group").removeClass("is--open");
        a = $(this).closest(".filter-group");
        a.hasClass("is--open") ? a.removeClass("is--open") : a.addClass("is--open")
    });
    $(document).on("click", function(a) {
        !$(a.target).closest(".filter-group").length && $(".filter-group").hasClass("is--open") && $(".filter-group").removeClass("is--open")
    });
    $("#CollectionFiltersForm").submit(function(a) {
        const b = new FormData(a.target.closest("form")),
            c = (new URLSearchParams(b)).toString();
        $.get(`${window.location.pathname}?section_id=collection-template&${c}`, function(e) {
            $("#collection-grid-0").html($(e).find("#collection-grid-0").html());
            $(".pagination--wrapper").html($(e).find(".pagination--wrapper").html());
            theme.updateCollectionPrices();
            history.pushState({
                searchParams: c
            }, "", `${window.location.pathname}${c&&"?".concat(c)}`)
        }, "html");
        a.preventDefault();
        return !1
    });
    $(document).on("click", ".filter-menu__link", function(a) {
        a.preventDefault();
        console.log("click");
        theme.isMobile() && $(".filters-inner").fadeToggle()
    })
};
theme.collectionFilters = function() {
    function a() {
        c = 0 < $(".coll--filter:checked").length;
        var d = "";
        $(".filter-group").removeClass("active");
        b.each(function() {
            var f = $(this);
            f.is(":checked") && (f.closest(".filter-group").find(".remove").show(), f.closest(".filter-group").addClass("active"), c = !0, d = "" == d ? "." + $(this).val() : d + "-" + $(this).val())
        });
        c ? $("body").addClass("is--filtered") : $("body").removeClass("is--filtered");
        $(".grid__item:visible").length ? $(".none-available--wrapper").hide() : $(".none-available--wrapper").show();
        isMobile() && $(".filters-inner").hide()
    }
    theme.updateFilterPricing(!1);
    var b = $(".coll-filter");
    $(".coll-filter-class");
    $(".coll-filter:checked");
    $("#Collection").data("collection-title");
    $(".products").data("collection-handle");
    var c = !1,
        e = $("#collection-grid-0").data("current-tags");
    a();
    theme.setCurrentTags(e);
    $(document).on("click", ".filter-menu__link", function(d) {
        d.preventDefault();
        console.log("click");
        theme.isMobile() && $(".filters-inner").fadeToggle()
    });
    $(".filter-group .fg-title").on("click", function(d) {
        d.preventDefault();
        isMobile() && $(this).next().slideToggle()
    });
    $(".filter-group");
    $(document).on("click", function(d) {
        !$(d.target).closest(".filter-group").length && $(".filter-group").hasClass("is--open") && $(".filter-group").removeClass("is--open")
    });
    $(document).on("click touchend", ".filter-group .fg-title", function(d) {
        d.preventDefault();
        $(".filter-group").removeClass("is--open");
        d = $(this).closest(".filter-group");
        d.hasClass("is--open") ? d.removeClass("is--open") : d.addClass("is--open")
    });
    $(".collection-filters .remove-all").on("click",
        function(d) {
            d.preventDefault();
            $(".filters .coll-filter").prop("checked", !1).removeAttr("checked").eq(0).trigger("change");
            $(".filters .remove").hide();
            $(this).removeClass("show");
            $(".fg-title").each(function(f, h) {
                f = $(this);
                f.html(f.data("original-title"))
            });
            $("body").removeClass("is--filtered")
        });
    $(document).on("click touchend", ".filter-group .remove", function(d) {
        d.preventDefault();
        d = $(this);
        d.closest(".filter-group").find(".coll-filter").prop("checked", !1).removeAttr("checked").eq(0).trigger("change");
        d.hide();
        d.closest(".filter-group").removeClass("is--filtered").removeClass("is--open");
        d = d.closest(".filter-group").find(".fg-title");
        var f = d.data("original-title");
        d.text(f);
        a()
    });
    $(document).on("change", ".coll-filter-class", function() {
        $(this).val();
        a()
    });
    $(document).on("change", ".coll-filter", function(d) {
        theme.applyFilters(d.target)
    });
    $(document).on("change", ".select-type .form-radio", function(d) {
        d.preventDefault();
        d = "/collections/" + $(this).parent().data("href");
        window.location.href = d
    })
};
theme.collectionFilter = function(a) {
    var b = `{
products(first: 20, query:"${a} -title:'Standard Sizes' -title:Clearance -title:'Pre-Sale' product_type:'Iron Doors' AND inventory_total:>=1", sortKey:TITLE) {
edges {
node {
id
title
variants(first:20) {
edges {
node {
title
availableForSale
}
}
}
}
}
}
}`,
        c = a.split(" ").join('" x ') + '"';
    a = {
        async: !0,
        crossDomain: !0,
        url: "//pinkysdoors.myshopify.com/api/graphql",
        method: "POST",
        headers: {
            "X-Shopify-Storefront-Access-Token": "ce74c601a7ae9787e896a6530c7cdc93",
            "Content-Type": "application/graphql"
        },
        data: b
    };
    console.log(c);
    return $.ajax(a).done(function(e) {
        $(e.data.products.edges).each(function(d, f) {
            $(f.node.variants.edges).each(function(h, g) {
                if (!g.node.availableForSale) return !0; - 1 != g.node.title.indexOf(c) && console.log(f.node.title)
            })
        })
    })
};
theme.isOnScreen = function(a) {
    if (0 != $(a).length) {
        var b = $(window),
            c = b.scrollTop();
        b = b.height();
        var e = c + b,
            d = $(a);
        a = d.offset().top;
        d = d.height();
        var f = a + d;
        return a >= c && a < e || f > c && f <= e || d > b && a <= c && f >= e
    }
};
theme.testAPI = function(a) {
    return $.ajax({
        async: !0,
        crossDomain: !0,
        url: "//pinkysdoors.myshopify.com/api/graphql",
        method: "POST",
        headers: {
            "X-Shopify-Storefront-Access-Token": "ce74c601a7ae9787e896a6530c7cdc93",
            "Content-Type": "application/graphql"
        },
        data: 'query($input:  {\nproducts(first:50, query: 72" x 96" "Right Hand In Swing" collection:92472705133 -Special -Clearance inventory_total:>1) {\nedges {\nnode {\ntitle \n}\n}\n} \n}'
    }).done(function(b) {
        console.log(b)
    })
};
theme.isPaging = !1;
theme.getNextPage = function(a) {
    theme.isPaging || $.get(a, function(b) {
        $(b).find("#collection-grid-0 .grid__item").each(function(c, e) {
            c = $(e).attr("id");
            $(`#${c}`).length || ($(e).appendTo("#collection-grid-0"), theme.updateFilterPricing())
        });
        $(b).find(".pagination--wrapper").length ? $(".pagination--wrapper").html($(b).find(".pagination--wrapper").html()) : $(".pagination--wrapper").remove();
        theme.finishCollectionProcessing();
        theme.isPaging = !1
    })
};
theme.preloaderVisible = function() {
    if (theme.isOnScreen(".next-page-preloader")) {
        var a = `${$(".next-page-preloader").attr("data-paginate-next-url")}&view=infinite-scroll`;
        theme.getNextPage(a);
        parseFloat($(".fixed-pagination__current").text());
        theme.isPaging = !0
    }
};
theme.isBelowViewportThreshold = function(threshold) {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  const invalidThreshold = (threshold === undefined || threshold === null) ? true : false;
  const isBelow = viewportWidth < threshold;
  return invalidThreshold ? false : isBelow;
};
theme.setFiltersMobileHeight = function(selector, threshold = 750) {
  if (selector) {
    const elem = document.querySelector(selector);
    let maxHeight = '';
    
    if (elem) {
      if (theme.isBelowViewportThreshold(threshold)) {
          maxHeight = theme.RS.helpers.calculateElementToViewportBottom(elem);
          const currentMaxHeight = parseFloat(elem.style.maxHeight);
    
          if (maxHeight && maxHeight > 0 && currentMaxHeight !== maxHeight) {
            maxHeight = `${maxHeight}px`;
          }
      }
      
      if (elem.dataset.maxHeight !== maxHeight) {
        elem.style.maxHeight = maxHeight;
        elem.dataset.maxHeight = maxHeight;
      }
    }
  }
};
theme.initFilterHeight = function() {
  const FILTER_FORM_SELECTOR = '#CollectionFiltersForm';
  const FILTER_SELECTOR = '.filter-group .fg-title';
  const FILTER_EVENTS = 'click touchend';
  const FILTER_THRESHOLD = 750;
  let listenerRegistered = false;
  let windowWidth = window.innerWidth || document.documentElement.clientWidth;

  function handleFilterGroupClick() {
    theme.setFiltersMobileHeight(FILTER_FORM_SELECTOR, FILTER_THRESHOLD);
  };
  function registerListener() {
    if (theme.isBelowViewportThreshold(FILTER_THRESHOLD)) {
      if (!listenerRegistered) {
        $(document).on(FILTER_EVENTS, FILTER_SELECTOR, handleFilterGroupClick);
        listenerRegistered = true;
      }
    } else if (listenerRegistered) {
      $(document).off(FILTER_EVENTS, FILTER_SELECTOR, handleFilterGroupClick);
      listenerRegistered = false;
    }
  };

  registerListener();
  theme.setFiltersMobileHeight(FILTER_FORM_SELECTOR, FILTER_THRESHOLD);

  $(window).resize(
    $.debounce(100, function() {
      const currentWidth = window.innerWidth || document.documentElement.clientWidth;
      if (windowWidth !== currentWidth) {
        registerListener();
        windowWidth = currentWidth;
      }
    })
  );
};

$(function() {
    theme.collectionFiltersNew();
    $(".next-page-preloader").length && (theme.preloaderVisible(), window.addEventListener("scroll", function(a) {
        theme.preloaderVisible()
    }))
    theme.initFilterHeight();
});